import React from "react"
import { dateFormatReceiver } from "@utils"
import { formatDate } from "@ui-seeker/utils"
import {Box, Typography} from "@mui/material";


export default function executionDateColumn() {

	return {
		name: "timestamp_last_execution",
		label: "Last Execution",
		options: {
			customBodyRowRender: value => <Box sx={{ display: "flex", alignItems: "center", justifyContent: "center" }}>
				<Typography>{formatDate(value, {
					isString: true,
					receivedFormat: dateFormatReceiver(value),
					format: "dd MMM yyyy HH:mm:ss"
				})}
				</Typography>
			</Box>
		}
	}
}